export default function SplashScreen() {
  return (
    <div data-testid="splash-screen" style={{
      position: 'fixed', inset: 0, background: '#FFFFFF',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', zIndex: 200
    }}>
      <img 
        src="/logo_vertical.jpg" 
        alt="PCOS Insights" 
        style={{ 
          width: '65%',
          maxWidth: 280,
          height: 'auto',
          objectFit: 'contain'
        }}
      />
      <p style={{
        fontSize: 13,
        color: '#A09CB0',
        letterSpacing: '0.14em',
        marginTop: 16,
        fontWeight: 500
      }}>
        Track &bull; Understand &bull; Manage
      </p>
    </div>
  );
}
